import { Trash2 } from "feather-icons-react/build/IconComponents";
import React from "react";
import { Link } from "react-router-dom";
const ViewExemptedProducts = () => {
  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        id="offcanvasViewExemptedProducts"
        tabIndex="-1"
        style={{ maxWidth: "40%" }}
      >
        <div className="offcanvas-header">
          <h4>View Exempted Products</h4>
          <button className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover table-center mb-0">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Category</th>

                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>Product 1</td>
                      <td>Category 1</td>

                      <td>
                        <Link
                          to="#"
                          className="confirm-text p-2 d-flex align-item-center"
                        >
                          <Trash2 className="feather-trash-2" />
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>Product 2</td>
                      <td>Category 2</td>
                      <td>
                        <Link
                          className="confirm-text p-2 d-flex align-item-center"
                          to="#"
                        >
                          <Trash2 className="feather-trash-2" />
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewExemptedProducts;
